import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { formatPhoneLocal } from "@ryde/shared";
import { landingInitDataAtom } from "@ryde/utils-landings";

export const PermissionDeniedError: FC = () => {
  const { t } = useTranslation();
  const { supportCenterPhone } = useRecoilValue(landingInitDataAtom) ?? {};

  return (
    <>
      <h1 className="landing-title">{t("landing.permissionDeniedError")}</h1>
      <div className="divider-bar" aria-hidden="true" />
      <div className="landing-sub-title">
        {t("landing.contactSupportMessage")}
      </div>

      {supportCenterPhone && (
        <a href={`tel:+${supportCenterPhone}`} className="blue-link">
          {formatPhoneLocal(supportCenterPhone)}
        </a>
      )}
    </>
  );
};
